export default "__VITE_ASSET__n_9Ey5Zd__"